/* eslint-disable react/prefer-stateless-function */
/* eslint-disable import/no-unresolved, import/extensions, import/no-extraneous-dependencies */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import copy from 'copy-to-clipboard';
import Avatar from '@material-ui/core/Avatar';
import CopyIcon from '@material-ui/icons/FilterNone';

import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import Fade from '@material-ui/core/Fade';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';

import {
  FacebookShareCount,
  GooglePlusShareCount,
  LinkedinShareCount,
  PinterestShareCount,
  VKShareCount,
  OKShareCount,
  RedditShareCount,
  TumblrShareCount,

  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  RedditShareButton,
  EmailShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  MailruShareButton,
  ViberShareButton,
  WorkplaceShareButton,
  LineShareButton,
  // WeiboShareButton,

  FacebookIcon,
  TwitterIcon,
  GooglePlusIcon,
  LinkedinIcon,
  PinterestIcon,
  VKIcon,
  OKIcon,
  TelegramIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  MailruIcon,
  EmailIcon,
  LivejournalIcon,
  ViberIcon,
  WorkplaceIcon,
  LineIcon,
} from 'react-share';

const styles = theme => ({
  shareDialogContainer :{
    padding : "0"
  },
  shareContainer : {
    textAlign: "center",
    margin: "10px"
  },
  "shareNetwork": {
    verticalAlign: "top",
    display: "inline-block",
    textAlign: "center",
    margin :"10px"
  },
  "shareCount" : {
    marginTop: "3px",
    fontSize: "12px"
  },
  "shareButton" : {
    cursor: "pointer"
  },
  "shareButton:hover:not(:active)" : {
    opacity: "0.75"
  },
  "copyIcon" : {
    color: "white"
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  }
})

class CopyToClipBoard extends React.Component {
  state = {
    open: false
  };
  handleClick = () => {
    copy(this.props.text);
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const { size, classes } = this.props;
    return (
      <div>
        <Avatar onClick={this.handleClick} className={classes.copyIcon} style={{ "width":size, "height": size }}>
          <CopyIcon />
        </Avatar>
        <Snackbar
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Fade}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">Copied to Clipboard</span>}
        />
      </div>
    );
  }
}


class ShareOptions extends Component {
  state = {
    open: false,
  }
  handleClickOpen = () => {
    this.setState({ open: true });
  }
  handleClose = () => {
    this.setState({ open: false });
  }
  render() {
    const { classes, shareUrl = "http://www.talkingstreet.in", shareTitle="Talking Street" ,shareImg = "https://www.talkingstreet.in/img/background1.jpg" } = this.props;
    const iconSize = 50;

    const shareButton = this.props.shareButton?<span onClick={this.handleClickOpen}>{this.props.shareButton}</span>:<Button variant="outlined" color="primary" onClick={this.handleClickOpen}>Share</Button>

    return (
      <span className={classes.shareDialogContainer}>
        {shareButton}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Share Options
            <IconButton aria-label="Close" className={classes.closeButton} onClick={this.handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Grid container className={classes.shareContainer}>
              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <FacebookShareButton
                    url={shareUrl}
                    quote={shareTitle}
                    className={classes.shareButton}>
                    <FacebookIcon
                      size={iconSize}
                      round />
                  </FacebookShareButton>
                  <FacebookShareCount
                    url={shareUrl}
                    className={classes.shareCount}>
                    {count => count}
                  </FacebookShareCount>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <TwitterShareButton
                    url={shareUrl}
                    title={shareTitle}
                    className={classes.shareButton}>
                    <TwitterIcon
                      size={iconSize}
                      round />
                  </TwitterShareButton>

                  <div className={classes.shareCount}>
                    &nbsp;
                  </div>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <TelegramShareButton
                    url={shareUrl}
                    title={shareTitle}
                    className={classes.shareButton}>
                    <TelegramIcon size={iconSize} round />
                  </TelegramShareButton>

                  <div className={classes.shareCount}>
                    &nbsp;
                  </div>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <WhatsappShareButton
                    url={shareUrl}
                    title={shareTitle}
                    separator=": "
                    className={classes.shareButton}>
                    <WhatsappIcon size={iconSize} round />
                  </WhatsappShareButton>

                  <div className={classes.shareCount}>
                    &nbsp;
                  </div>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <GooglePlusShareButton
                    url={shareUrl}
                    className={classes.shareButton}>
                    <GooglePlusIcon
                      size={iconSize}
                      round />
                  </GooglePlusShareButton>

                  <GooglePlusShareCount
                    url={shareUrl}
                    className={classes.shareCount}>
                    {count => count}
                  </GooglePlusShareCount>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <LinkedinShareButton
                    url={shareUrl}
                    title={shareTitle}
                    windowWidth={750}
                    windowHeight={600}
                    className={classes.shareButton}>
                    <LinkedinIcon
                      size={iconSize}
                      round />
                  </LinkedinShareButton>

                  <LinkedinShareCount
                    url={shareUrl}
                    className={classes.shareCount}>
                    {count => count}
                  </LinkedinShareCount>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <PinterestShareButton
                    url={String(window.location)}
                    media={`${String(window.location)}/${shareImg}`}
                    windowWidth={1000}
                    windowHeight={730}
                    className={classes.shareButton}>
                    <PinterestIcon size={iconSize} round />
                  </PinterestShareButton>

                  <PinterestShareCount url={shareUrl}
                    className={classes.shareCount} />
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <VKShareButton
                    url={shareUrl}
                    image={`${String(window.location)}/${shareImg}`}
                    windowWidth={660}
                    windowHeight={460}
                    className={classes.shareButton}>
                    <VKIcon
                      size={iconSize}
                      round />
                  </VKShareButton>

                  <VKShareCount url={shareUrl}
                    className={classes.shareCount} />
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <OKShareButton
                    url={shareUrl}
                    image={`${String(window.location)}/${shareImg}`}
                    windowWidth={660}
                    windowHeight={460}
                    className={classes.shareButton}>
                    <OKIcon
                      size={iconSize}
                      round />
                  </OKShareButton>

                  <OKShareCount url={shareUrl}
                    className={classes.shareCount} />
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <RedditShareButton
                    url={shareUrl}
                    title={shareTitle}
                    windowWidth={660}
                    windowHeight={460}
                    className={classes.shareButton}>
                    <RedditIcon
                      size={iconSize}
                      round />
                  </RedditShareButton>

                  <RedditShareCount url={shareUrl}
                    className={classes.shareCount} />
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <TumblrShareButton
                    url={shareUrl}
                    title={shareTitle}
                    windowWidth={660}
                    windowHeight={460}
                    className={classes.shareButton}>
                    <TumblrIcon
                      size={iconSize}
                      round />
                  </TumblrShareButton>

                  <TumblrShareCount url={shareUrl}
                    className={classes.shareCount} />
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <LivejournalShareButton
                    url={shareUrl}
                    title={shareTitle}
                    description={shareUrl}
                    className={classes.shareButton}
                  >
                    <LivejournalIcon size={iconSize} round />
                  </LivejournalShareButton>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <MailruShareButton
                    url={shareUrl}
                    title={shareTitle}
                    className={classes.shareButton}>
                    <MailruIcon
                      size={iconSize}
                      round />
                  </MailruShareButton>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <EmailShareButton
                    url={shareUrl}
                    subject={shareTitle}
                    body="body"
                    className={classes.shareButton}>
                    <EmailIcon
                      size={iconSize}
                      round />
                  </EmailShareButton>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <ViberShareButton
                    url={shareUrl}
                    title={shareTitle}
                    body="body"
                    className={classes.shareButton}>
                    <ViberIcon
                      size={iconSize}
                      round />
                  </ViberShareButton>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <WorkplaceShareButton
                    url={shareUrl}
                    quote={shareTitle}
                    className={classes.shareButton}>
                    <WorkplaceIcon
                      size={iconSize}
                      round />
                  </WorkplaceShareButton>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork} onClick={this.handleClose}>
                  <LineShareButton
                    url={shareUrl}
                    title={shareTitle}
                    className={classes.shareButton}>
                    <LineIcon
                      size={iconSize}
                      round />
                  </LineShareButton>
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.shareNetwork}>
                  <CopyToClipBoard classes={classes} text={shareUrl} size={iconSize} />
                </div>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </span>
    );
  }
}

export default withStyles(styles)(ShareOptions);